'use client';

import { useEffect, useRef, useState } from 'react';
import styles from '../baselineSummit.module.scss';

const SummitHeroBackground = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (imageRef.current?.complete) {
      setIsLoaded(true);
    }
  }, []);

  return (
    <picture
      className={styles.heroBackground}
      data-testid="summit-hero-background"
    >
      <source
        media="(max-width: 768px)"
        srcSet="/events/baseline-summit/mobile-background-375.webp 375w, /events/baseline-summit/mobile-background-750.webp 750w, /events/baseline-summit/mobile-background-1000.webp 1000w"
        sizes="100vw"
        type="image/webp"
      />
      <img
        src="/events/baseline-summit/desktop-background-1440.webp"
        srcSet="/events/baseline-summit/desktop-background-720.webp 720w, /events/baseline-summit/desktop-background-1440.webp 1440w"
        sizes="100vw"
        alt=""
        aria-hidden="true"
        className={styles.heroBackgroundImage}
        data-loaded={isLoaded}
        ref={imageRef}
        onLoad={() => setIsLoaded(true)}
      />
    </picture>
  );
};

export default SummitHeroBackground;
